/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Test_Print_Confirm_TitleInputs */

const vi_print_admin_test_print_confirm_title = /** @type {(inputs: Print_Admin_Test_Print_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lệnh in thử?`)
};

/**

* @param {Print_Admin_Test_Print_Confirm_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_test_print_confirm_title = /** @type {((inputs?: Print_Admin_Test_Print_Confirm_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Test_Print_Confirm_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_test_print_confirm_title(inputs)
});